import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  gap: 1.5rem;
  width: 100%;
`;
